// // src\themes\tolica\elements\Header\HeaderShell.tsx
// "use client"

// import { useEffect, useState } from "react"

// export default function HeaderShell({ children }: { children: React.ReactNode }) {
//     const [scrolled, setScrolled] = useState(false)

//     useEffect(() => {
//         const onScroll = () => setScrolled(window.scrollY > 20)
//         window.addEventListener("scroll", onScroll, { passive: true })
//         return () => window.removeEventListener("scroll", onScroll)
//     }, [])

//     return (
//         <header
//             className={`
//         m-auto sticky top-0 z-50 print:hidden
//         flex items-center justify-between
//         px-4 sm:px-6 lg:px-12
//         transition-all duration-300 ease-out bg-neutral-950/90
//         ${scrolled
//                     ? "h-14 shadow-lg shadow-primary-900/5"
//                     : "h-20 "
//                 }
//       `}
//             data-scrolled={scrolled}
//         >
//             {children}
//         </header>
//     )
// }


// src\themes\tolica\elements\Header\HeaderShell.tsx
"use client"

import { useHeaderScrolled } from "@/core/hooks/use-header-scrolled"

export default function HeaderShell({ children }: { children: React.ReactNode }) {
    const scrolled = useHeaderScrolled()

    return (
        <header
            className={`
        m-auto sticky top-0 z-50 print:hidden
        flex items-center justify-between
        px-4 sm:px-6 lg:px-12
        transition-all duration-300 ease-out bg-neutral-950/90
        ${scrolled
                    ? "h-14 shadow-lg shadow-primary-900/5"
                    : "h-20 "
                }
      `}
            data-scrolled={scrolled}
        >
            {children}
        </header>
    )
}